// components/layout/ConditionalHeader.tsx
'use client';

import { usePathname } from 'next/navigation';
import PublicHeader from './PublicHeader';

export default function ConditionalHeader() {
  const pathname = usePathname();

  // 인증 페이지는 Header 없음
  if (pathname.startsWith('/auth')) {
    return null;
  }

  // public 경로나 홈페이지는 PublicHeader
  if (pathname.startsWith('/public') || pathname === '/') {
    return <PublicHeader />;
  }

  // 나머지(로그인 후 페이지)는 Header 없음
  // 각 레이아웃에서 자체적으로 Header를 관리
  return null;
}
